import { useCustom } from "@refinedev/core";

type FeatureFlags = Record<string, boolean>;

export const useFeature = (flagName: string) => {
  const { data, isLoading, error, refetch } = useCustom<FeatureFlags>({
    url: `/api/system/features`,
    method: "get",
    queryOptions: {
      staleTime: 1000 * 60 * 60, // 1 hour
      cacheTime: 1000 * 60 * 60, // 1 hour
    },
    errorNotification: false, // silent in ui
  });

  if (error) {
    console.error("Error fetching feature flags:", error);
    return {
      isLoading,
      isEnabled: false,
      refreshFlag: refetch,
    };
  }
  const value = data?.data?.[flagName];

  return {
    isLoading,
    isEnabled: value === true,
    refreshFlag: refetch,
  };
};
export const useFeatureFlag = (flagName: string) => {
  return useFeature(flagName).isEnabled;
};

export const useEnabledFeatures = () => {
  const { data, isLoading, error, refetch } = useCustom<FeatureFlags>({
    url: `/api/system/features`,
    method: "get",
    queryOptions: {
      staleTime: 1000 * 60 * 60, // 1 hour
      cacheTime: 1000 * 60 * 60, // 1 hour
    },
    errorNotification: false, // silent in ui
  });
  if (error) {
    console.error("Error fetching feature flags:", error);
    return {
      isLoading,
      features: null,
      refreshFlag: refetch,
    };
  }
  return {
    isLoading,
    features: isLoading
      ? null
      : Object.entries(data?.data)
          .filter(([, value]) => value === true)
          .map(([featureName]) => featureName),
    refetch,
  };
};
